export const TIME_TYPES = {
  1: 'ST',
  2: 'OT',
  3: 'DT',
  4: 'NB',
  5: 'OTH',
  6: 'HOL',
  7: 'SICK',
  8: 'PTO'
}

export function timeTypeCode (timeTypeId) {
  return TIME_TYPES[timeTypeId] || String(timeTypeId)
}

// Time Off behavior keys on the catalog's isTimeOff marker (ADR 0014), never on the ids below.
export function activeTimeOffTypes (timeTypesList) {
  return (timeTypesList || []).filter(type => type.isTimeOff && type.active)
}

export function isTimeOffType (timeTypesList, timeTypeId) {
  return (timeTypesList || []).some(type => type.isTimeOff && type.id === timeTypeId)
}

export const STANDARD_TIME = 1

export const OVERTIME = 2

export const DOUBLE_TIME = 3

export const NON_BILLABLE = 4

export const OTHER = 5
